import { teamMembers, milestones } from '@/mocks/services';

export default function BrandIntro() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center mb-20">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4">
              品牌介绍
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6">
              用创意驱动品牌增长
            </h2>
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                果冻传媒成立于2015年，总部位于北京，是一家专注创意内容生产与品牌传播的专业机构。我们汇聚了来自4A广告公司、头部互联网平台和顶级内容机构的顶尖人才，致力于为中国品牌提供世界级的创意解决方案。
              </p>
              <p>
                我们坚信，好的内容自带传播力。果冻传媒从创立之初就确立了"内容为王、创意驱动"的核心理念，帮助品牌在信息过载的时代脱颖而出，建立与消费者的深度情感连接。
              </p>
              <p>
                经过多年发展，果冻传媒已成长为拥有200+专业人才的综合性创意传播机构，服务覆盖短视频制作、社交媒体运营、广告策划、全案营销和内容创意五大领域。
              </p>
              <p>
                我们的使命是：<strong>用创意连接品牌与消费者，让每一次传播都产生价值。</strong>
              </p>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20creative%20agency%20team%20collaborating%20in%20bright%20open%20office%20space%20with%20warm%20lighting%2C%20diverse%20professional%20team%20around%20wooden%20table%20with%20laptops%20and%20creative%20materials%2C%20large%20windows%20with%20natural%20light%2C%20inspiring%20atmosphere%2C%20editorial%20photography%2C%20soft%20warm%20tones%20with%20coral%20accents&width=700&height=500&seq=about-brand-intro-01&orientation=landscape"
              alt="果冻传媒团队"
              className="w-full rounded-lg"
              title="果冻传媒创意团队"
            />
          </div>
        </div>

        <div className="mb-20">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-sm font-medium mb-4">
              核心团队
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              顶尖创意人才的聚集地
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              核心成员来自奥美、麦肯锡、字节跳动等顶级机构，兼具国际视野与本土洞察
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {teamMembers.map((member) => (
              <div key={member.name} className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                    title={`果冻传媒${member.name}`}
                  />
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">{member.name}</h3>
                <p className="text-xs text-primary-600 font-medium mb-2">{member.title}</p>
                <p className="text-xs text-foreground-500 leading-relaxed">{member.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-sm font-medium mb-4">
              发展历程
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              每一步，都为更好的创意
            </h2>
          </div>
          <div className="relative">
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
            <div className="space-y-10">
              {milestones.map((item, index) => (
                <div key={item.year} className={`relative flex flex-col md:flex-row gap-6 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                  <div className="md:w-1/2 flex items-center gap-4 md:justify-end">
                    <div className={`flex-1 md:text-right ${index % 2 === 1 ? 'md:text-left md:pl-14' : 'md:pr-14'}`}>
                      <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                        <span className="font-heading text-lg font-bold text-primary-600">{item.year}</span>
                        <p className="text-sm text-foreground-600 mt-1">{item.event}</p>
                      </div>
                    </div>
                  </div>
                  <div className="absolute left-4 md:left-1/2 w-3 h-3 bg-primary-500 rounded-full -translate-x-1/2 mt-7 border-2 border-background-50"></div>
                  <div className="md:w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}